import { AccountLicenseTier } from '../admin/index';
import { DataTableHeader } from '@/components/types/DataTable';
import { Device } from '../inventory/Device';

export interface Organisation extends Record<string, unknown> {
  uuid: string;
  createdAt: string;
  updatedAt: string;
  address1?: string;
  address2?: string;
  city?: string;
  countryCode: string;
  customerNumber?: string;
  emailAddress?: string;
  name: string;
  phoneNumber?: string;
  postalCode?: string;
  roles: string[];
  state?: string;
  supplierUuid?: string;
  validated: boolean;
  totpEnforced: boolean;
  ssoEnabled: boolean;
  isInSSOGracePeriod: boolean;
}

export interface AccountMembershipType {
  uuid: string;
  createdAt?: string;
  updatedAt?: string;
  accountUuid: string;
  userUuid: string;
  isHomeAccount: boolean;
}

export interface CredentialType {
  uuid: string;
  createdAt?: string;
  updatedAt?: string;
  passwordSetAt: string;
  locked: boolean;
  userUuid: string;
  lastLoginAt: string;
  lastLogoutAt: string;
  userInfoLastLoginAt: string;
  userInfoLastLoginFailedAt: string;
  userInfoLastLoginFailedCount: string;
  totpEnabled: boolean;
}

export interface User extends Record<string, unknown> {
  uuid: string;
  createdAt?: string;
  updatedAt?: string;
  confirmed: boolean;
  emailAddress: string;
  firstName: string;
  lastName: string;
  middleName: string;
  organisationUuid: string;
  organisation?: Organisation;
  organisationName?: string;
  phoneNumber: string;
  preferredLanguage: string;
  registeredAt: string;
  salutation: string;
  title: string;
  username: string;
  accountMemberships: AccountMembershipType[];
  credential: CredentialType;
  release: ReleaseType;
  status?: InvitationState;
  ssoRequired: boolean;
}

export interface InvitationInformation extends Record<string, unknown> {
  firstName: string;
  lastName: string;
  passwordRequired: boolean;
}
export interface InviteUserRequest extends Record<string, unknown> {
  firstName: string;
  lastName: string;
  emailAddress: string;
  allowBypassSSO?: boolean;
}
export interface CreateUserRequest extends Record<string, unknown> {
  accountUuid: string;
  preferredLanguage: string;
  organisationUuid: string;
  username: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  password: string;
  allowBypassSSO: boolean;
}

export interface ReleaseType {
  uuid: string;
  createdAt?: string;
  updatedAt?: string;
  version: string;
  releaseNotesUrl: string;
  releaseDate: string;
}

export interface UserFields {
  devices: DataTableHeader<Device>[];
}

export interface Account extends Record<string, unknown> {
  category: string;
  type: string;
  uuid: string;
  createdAt?: string;
  updatedAt?: string;
  name: string;
  organisationUuid: string;
  organisation?: Organisation;
  accountMemberships?: AccountMembershipType[];
  namespace: string;
  internal?: boolean;
  userFields?: UserFields;
  licenseTier: AccountLicenseTier;
}

export interface CustomFieldType extends Record<string, unknown> {
  label: string;
  name: string;
}
export interface Setting {
  name: string;
  value: unknown;
}

export enum OrganisationRole {
  CUSTOMER = 'CUSTOMER',
  SUPPLIER = 'SUPPLIER',
  BROKER = 'BROKER',
  RESELLER = 'RESELLER',
  PLATFORM_OPERATOR = 'PLATFORM_OPERATOR'
}

export enum InvitationState {
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  INVITED = 'INVITED',
  EXPIRED = 'EXPIRED',
  APPROVED = 'APPROVED'
}
